import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';

import { Button, Grid, Typography, withStyles } from '@material-ui/core';

import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';

import swal from '@sweetalert/with-react';

import axiosInstance, { EVENT_ID, getUserID, WEB_API } from '../constatns';

const styles = (theme) => ({
  button_top: {
    textTransform: 'none',
    height: '90px',
    width: '300px',
    '& span': {
      fontSize: 20,
    },
  },
  button_bottom: {
    textTransform: 'none',
    height: '90px',
    width: '300px',
    '& span': {
      fontSize: 20,
      color: '#006400',
    },
  },
});

class PdfDownload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:600px)').matches,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    if (sessionStorage.getItem('_in_user_')) {
      this.setState({
        user: sessionStorage.getItem('_in_user_'),
      });
      this.getRegData();
    }
  }
  getRegData = () => {
    axiosInstance.get(`${WEB_API}/user/info?eventId=${EVENT_ID}&userId=${getUserID()}`).then((res) => {
      if (res.data.Item && res.data.Item.status === 'Complete') {
        this.setState({ isReg: true });
      }
    });
  };

  handleChange(type, e) {
    this.setState({ [type]: e.target.value });
  }

  checkDownload = () => {
    if (this.state.user) {
      if (this.state.isReg && this.state.isReg == true) {
        window.open(`https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/PRS+KOREA+2022+abstract_book.pdf`, '_blank');
        // swal('Abstract Book Download', 'To be updated.', 'info');
      } else {
        swal('Abstract Book Download', 'registration is required.', 'info');
      }
    } else {
      swal('Abstract Book Download', 'Please Login to use.', 'info');
      this.props.history.push('signin');
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <CssBaseline />
        <Topbar MIdx={1} SIdx={4} />
        <Container>
          <Grid container justifyContent="center" alignItems="center">
            <Grid item xs={8}>
              <MainTitle>Downloads</MainTitle>
              <Grid
                container
                justifyContent="flex-start"
                alignItems="center"
                item
                xs={12}
                style={{ padding: '20px', margin: '20px 0', border: '1px solid #237a9d' }}
              >
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    window.open(`https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/PRS+Korea+2022+Program+Book.pdf`, '_blank');
                    // swal('Program Book Download', 'To be updated.', 'info');
                  }}
                  className={classes.button_top}
                >
                  <span>Program Book Download</span>
                </Button>
                <Grid style={{ paddingLeft: 24 }}>
                  <Typography style={{ fontSize: 20, color: '#1E90FF' }}>For all users.</Typography>
                </Grid>
              </Grid>
              <Grid
                container
                item
                xs={12}
                style={{ padding: '20px', margin: '20px 0', border: '1px solid #aacb3c' }}
                justifyContent="flex-start"
                alignItems="center"
              >
                <Button
                  color="secondary"
                  variant="contained"
                  onClick={() => {
                    this.checkDownload();
                  }}
                  className={classes.button_bottom}
                >
                  <span>Abstract Book Download</span>
                </Button>
                <Grid style={{ paddingLeft: 24 }}>
                  <Typography style={{ fontSize: 20, color: '#CD1039' }}>For registered users only.</Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(PdfDownload);
